import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CoachtrainingComponent } from './coachtraining.component';
import { CoachtrainingHomeComponent } from './components/home/coachtraining-home.component';
import { CoachtrainingDepartmentComponent } from './components/department/coachtraining-department.component';
import { CoachtrainingAffiliationComponent } from './components/affiliation/coachtraining-affiliation.component';
import { CoachtrainingCourseComponent } from './components/course/coachtraining-course.component';
import { CoachtrainingCalendarComponent } from './components/calendar/coachtraining-calendar.component';
import { CoachtrainingSngpComponent } from './components/sngp/coachtraining-sngp.component';
import { CoachtrainingTeacherComponent } from './components/teacher/coachtraining-teacher.component';
import { CoachtrainingCertificationComponent } from './components/certification/coachtraining-certification.component';
import { CoachtrainingAttachedComponent } from './components/attached/coachtraining-attached.component';
import { CoachTrainingEventsComponent } from './components/events/events.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: CoachtrainingComponent,
        children: [
            { path: 'home', component: CoachtrainingHomeComponent },
            { path: 'department', component: CoachtrainingDepartmentComponent },
            { path: 'affiliation', component: CoachtrainingAffiliationComponent },
            { path: 'course', component: CoachtrainingCourseComponent },
            { path: 'calendar', component: CoachtrainingCalendarComponent },
            { path: 'sngp', component: CoachtrainingSngpComponent },
            { path: 'teacher', component: CoachtrainingTeacherComponent },
            { path: 'certification', component: CoachtrainingCertificationComponent },
            { path: 'attached/:sessionType', component: CoachtrainingAttachedComponent },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
            { path: 'attached_text/:sessionType', component: CoachtrainingAttachedComponent },
            { path: 'events', component: CoachTrainingEventsComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoachtrainingRoutingModule {}
